// Н5 — един ред от формите за площи: етикет + поле.
//
// Досегашният `OtherNew.js` беше 264 реда, в които ЦЯЛАТА форма беше написана
// два пъти — веднъж за „Прибави" и веднъж за „Редактирай". Всяка поправка
// трябваше да се направи на два места, а разделянето на два екрана щеше да го
// направи четири. Затова полето е тук, а екраните само го подреждат.
export const AreaField = ({
    id, label, name, value, onChange,
    type = "number", step = "0.01", min, placeholder, wide = false, hint,
}) => (
    <div className="row g-3 align-items-center">
        <div className="col-2">
            <label htmlFor={id} className="col-form-label">{label}</label>
        </div>
        <div className={wide ? "col-6" : "col-3"} style={{marginLeft: "10px"}}>
            <input
                className="form-control"
                id={id}
                name={name}
                type={type}
                step={type === "number" ? step : undefined}
                min={min}
                placeholder={placeholder}
                value={value ?? ''}
                onChange={onChange}
            />
            {hint && (
                <div className="form-text" style={{color: "var(--app-muted)"}}>{hint}</div>
            )}
        </div>
    </div>
);
